import Router, { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

import Head from 'next/head';
import getMetaTagData from '../src/common/services/getMetaTagData';
import MainTop from '../src/component/pc/maintop/MainTop';
import MainBottom from '../src/component/pc/MainBottom/MainBottom';

function HistoryGraph({ metaTagData, jWTCheck }) {
  const [ScrollY, setScrollY] = useState(0); // 스크롤값을 저장하기 위한 상태
  const handleFollow = () => {
    setScrollY(window.pageYOffset); // window 스크롤 값을 ScrollY에 저장
  };

  useEffect(() => {
    // console.log('find data childmild ---->>> ScrollY is ', ScrollY); // ScrollY가 변화할때마다 값을 콘솔에 출력
    if (ScrollY > 504) {
      document.getElementById('wrap').className = 'sbsabout_wrap sorting_fixed';
    } else {
      document.getElementById('wrap').className = 'sbsabout_wrap';
    }
  }, [ScrollY]);

  useEffect(() => {
    const watch = () => {
      window.addEventListener('scroll', handleFollow);
    };
    watch(); // addEventListener 함수를 실행
    return () => {
      window.removeEventListener('scroll', handleFollow); // addEventListener 함수를 삭제
    };
  }, []);

  const [btnState, setBtnState] = useState(2); // 상단탭 영역 상태값
  const [title, setTitle] = useState(''); // 타이틀 상태값

  const sectionStyle = {
    backgroundImage: 'url(styles/2022/pc/img/history_graph_visual.png)'
  };

  const sectionStyle1 = {
    backgroundImage: 'url(styles/2022/pc/img/history_graph_90-99.png)'
  };

  const sectionStyle2 = {
    backgroundImage: 'url(styles/2022/pc/img/history_graph_00-09.png)'
  };

  const sectionStyle3 = {
    backgroundImage: 'url(styles/2022/pc/img/history_graph_10-20.png)'
  };

  //   const sectionStyle4 = {
  //     backgroundImage: 'url(styles/2022/pc/img/history_graph_21-now.png)'
  //   };

  const btnState01 = () => {
    // Router.push({
    //   pathname: '/history_graph',
    //   query: { type: 0 }
    // });
    location.href = "/history_graph?type=0";
  };

  const btnState02 = () => {
    // Router.push({
    //   pathname: '/history_graph',
    //   query: { type: 1 }
    // });
    location.href = "/history_graph?type=1";
  };

  const btnState03 = () => {
    // Router.push({
    //   pathname: '/history_graph',
    //   query: { type: 2 }
    // });
    location.href = "/history_graph?type=2";
  };

  const router = useRouter();
  useEffect(() => { // btn state 부분제어 하는 영역
    setBtnState(router.query.type);
  }, [router]);

  useEffect(() => { // btn state 부분제어 하는 영역
    const state = router.query.type;
    if (state === '0') {
      setBtnState(0);
      setTitle('1990-1999 : 연혁 : SBS 소개 : SBS');
      document.getElementById('tab_0').style.display = 'block';
      document.getElementById('tab_1').style.display = 'none';
      document.getElementById('tab_2').style.display = 'none';
    } else if (state === '1') {
      setTitle('2000-2009 : 연혁 : SBS 소개 : SBS');
      setBtnState(1);
      document.getElementById('tab_0').style.display = 'none';
      document.getElementById('tab_1').style.display = 'block';
      document.getElementById('tab_2').style.display = 'none';
    } else if (state === '2') {
      setTitle('2010-2020 : 연혁 : SBS 소개 : SBS');
      setBtnState(2);
      document.getElementById('tab_0').style.display = 'none';
      document.getElementById('tab_1').style.display = 'none';
      document.getElementById('tab_2').style.display = 'block';
    } else {
      setTitle('2010-2020 : 연혁 : SBS 소개 : SBS');
      setBtnState(2);
      document.getElementById('tab_0').style.display = 'none';
      document.getElementById('tab_1').style.display = 'none';
      document.getElementById('tab_2').style.display = 'block';
    }
  }, [btnState]);

  // gtag
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      window.dataLayer = window.dataLayer || [];
      function gtag() { dataLayer.push(arguments); }
      gtag('js', new Date());
      gtag('config', 'UA-104756746-1');
      gtag('config', 'G-L9E7Y63ZNE');
    }
  }, []);

  return (
    <>
      <script async src='https://www.googletagmanager.com/gtag/js?id=UA-104756746-1' />
      <Head>
        <link key='css_pc_url' rel='stylesheet' href={process.env.NEXT_PUBLIC_GLOBAL_CSS_PC_URL} />
        <meta key='viewport' name='viewport' content='width=device-width, initial-scale=1' />
        <meta name='description' content='SBS의 대표 프로그램과 서비스 등 30년 히스토리와 최근 소식을 만나보세요!' />
        <meta name='keywords' content={metaTagData.keywords} />
        <meta name='twitter:card' content='summary' />
        <noscript>Your browser does not support JavaScript!</noscript>
        <meta property='og:type' content='website' />
        <meta property='og:locale' content='ko_KR' />
        <meta property='og:site_name' content='SBS' />
        <meta property='og:title' content={'' || ''} />
        <meta property='og:description' content={'SBS의 대표 프로그램과 서비스 등 30년 히스토리와 최근 소식을 만나보세요!' || ''} />
        <meta property='og:image' content={metaTagData.shareImageUrl || ''} />
        <meta property='og:url' content={metaTagData.currentUrl || ''} />
        <meta name='nate:site_name' content='SBS' />
        <meta name='nate:title' content={'' || ''} />
        <meta name='nate:description' content={'SBS의 대표 프로그램과 서비스 등 30년 히스토리와 최근 소식을 만나보세요!' || ''} />
        <meta name='nate:image' content={metaTagData.shareImageUrl || ''} />
        <meta name='nate:url' content={metaTagData.currentUrl || ''} />
        <title>{title}</title>
      </Head>

      <ul id='skip_nav'>
        <li><a href='#container'>본문컨텐츠</a></li>
        <li><a href='#header'>헤더 메뉴</a></li>
      </ul>

      <div id='wrap' className='sbsabout_wrap'>
        {/* <!-- 헤더 --> */}
        <MainTop />
        {/* <!-- 컨텐츠영역 --> */}
        {/* <!-- contents에 년도별 클래스 추가로 제어 "historyGraph1990,historyGraph2000,historyGraph2010,historyGraph2021" --> */}
        <div id='container' className='contents historyGraph2010'>
          <h2 className='hide'>SBS</h2>
          {/* <!-- 비쥬얼영역 --> */}
          <div className='sbsabout_visual_top_history' style={sectionStyle}>
            <div className='sbsabout_inner'>
              <h3 className='sbsabout_visual_title'>연혁</h3>
            </div>
          </div>
          {/* <!-- 탭 --> */}
          <div className='module_tablist_w'>
            <div className='sbsabout_inner'>
              <ul className='module_tablist'>
                <li className={`module_tablist_inner ${btnState === 0 ? 'current' : ''}`}>
                  <a href='#none' onClick={btnState01} className='module_tablink'>1990-1999</a>
                </li>
                <li className={`module_tablist_inner ${btnState === 1 ? 'current' : ''}`}>
                  <a href='#none' onClick={btnState02} className='module_tablink'>2000-2009</a>
                </li>
                <li className={`module_tablist_inner ${btnState === 2 ? 'current' : ''}`}>
                  <a href='#none' onClick={btnState03} className='module_tablink'>2010-2020</a>
                </li>
                {/* <li className='module_tablist_inner'>
                  <a href='#none' className='module_tablink'>2021-현재</a>
                </li> */}
              </ul>
            </div>
          </div>
          {/* <!-- 컨텐츠 --> */}
          <div className='historygraph_contents_w'>
            {/* <!-- 1990 --> */}
            <div className='sbsabout_inner tablist_1990' id='tab_0'>
              <div className='tab_term_w' style={sectionStyle1}>
                <div className='tab_term_cont'>
                  <strong className='tab_term_years'>1990-1999</strong>
                </div>
              </div>
              <div className='history_list_w'>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>1990</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>10.31</strong>
                      <span className='history_text'>새 민방(서울방송)의 지배주주로 ㈜태영 선정</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>11.14</strong>
                      <span className='history_text'>SBS 창사(대표이사 윤세영 사장)</span>
                    </div>
                  </dd>
                </dl>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>1991</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>03.20</strong>
                      <span className='history_text'>라디오 개국</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>12.09</strong>
                      <span className='history_text'>SBSTV(Ch6) 개국</span>
                    </div>
                  </dd>
                </dl>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>1992</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>03.31</strong>
                      <span className='history_text'>&#60;그것이 알고 싶다&#62; 첫 방송 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>05.11</strong>
                      <span className='history_text'>프로덕션 설립</span>
                    </div>
                  </dd>
                </dl>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>1993</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>07.01</strong>
                      <span className='history_text'>국내 최초 AM 스테레오방송 실시</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>10.25</strong>
                      <span className='history_text'>SBS문화재단 설립</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>12.09</strong>
                      <span className='history_text'>등촌동 공개홀 개관</span>
                    </div>
                  </dd>
                </dl>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>1994</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>01.26</strong>
                      <span className='history_text'>SBS 프로듀서협회 창립</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>03.12</strong>
                      <span className='history_text'>윤세영 회장, 윤혁기 사장 취임</span>
                    </div>
                  </dd>
                </dl>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>1995</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>01.09</strong>
                      <span className='history_text'>광복50주년 특별기획 모래시계 첫 방송</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>03.16</strong>
                      <span className='history_text'>SBS기술인협회 창립 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>05.14</strong>
                      <span className='history_text'>전국 네트워크 출범 (부산 PSB, 대구 TBC, 광주 KBC, 대전 TJB 개국)</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>11.14</strong>
                      <span className='history_text'>SBS 탄현제작센터 준공 (1998.05.21. 일산제작센터로 개명)</span>
                    </div>
                  </dd>
                </dl>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>1996</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>02.05</strong>
                      <span className='history_text'>SBS방송아카데미 개원</span>
                    </div>
                  </dd>
                </dl>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>1998</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>07.01</strong>
                      <span className='history_text'>국내 방송사 최초, SBS 인터넷 보도국 신설 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>08.01</strong>
                      <span className='history_text'>방송사 최초 인터넷 쇼핑 사업 시작 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>08.10</strong>
                      <span className='history_text'>한국 방송사상 최초 북한공식취재 방송 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>10.26</strong>
                      <span className='history_text'>SBS 노동조합 창립</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>11.20</strong>
                      <span className='history_text'>SBS 아트텍, SBS 뉴스텍과 영업양수도 계약 조인 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>11.28</strong>
                      <span className='history_text'>SBS 사우회 창립 총회 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>12.01</strong>
                      <span className='history_text'>SBS 아트텍, SBS 뉴스텍 설립 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>12.15</strong>
                      <span className='history_text'>제1회 SBS문화재단 TV문학상 시상 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>12.15</strong>
                      <span className='history_text'>표준FM(103.5MHz) 시험방송 송출식</span>
                    </div>
                  </dd>
                </dl>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>1999</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>01.01</strong>
                      <span className='history_text'>SBS LOVE FM(103.5MHz) 개국</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>03.12</strong>
                      <span className='history_text'>우리 사주 조합 창립총회 개최 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>05.14</strong>
                      <span className='history_text'>언론사 최초 코스닥 등록 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>06.25</strong>
                      <span className='history_text'>마이클 잭슨 국내 공연, 세계 최초 전 세계 생중계 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>07.12</strong>
                      <span className='history_text'>SBS 골프채널 설립</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>08.21</strong>
                      <span className='history_text'>SBS 인터넷 설립</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>08.31</strong>
                      <span className='history_text'>비디오 연동 시청률 분석 시스템(VIVA) 개발</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>12.05</strong>
                      <span className='history_text'>방송사상 최초 북한에서 이산가족 상봉 공식 취재</span>
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            {/* <!-- 2000 --> */}
            <div className='sbsabout_inner tablist_2000' id='tab_1'>
              <div className='tab_term_w' style={sectionStyle2}>
                <div className='tab_term_cont'>
                  <strong className='tab_term_years'>2000-2009</strong>
                </div>
              </div>
              <div className='history_list_w'>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>2000</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>02.16</strong>
                      <span className='history_text'>SBS스포츠 설립 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>03.01</strong>
                      <span className='history_text'>SBS미디어넷 출범</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>03.17</strong>
                      <span className='history_text'>서울방송 → ㈜에스비에스(SBS) 사명 변경</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>03.18</strong>
                      <span className='history_text'>2000 SBS 톱탤런트 선발대회 개최</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>03.25</strong>
                      <span className='history_text'>SBS인터넷 → ㈜SBSi 사명 변경</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>08.31</strong>
                      <span className='history_text'>국내 최초 HDTV 시험방송 실시</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>09.01</strong>
                      <span className='history_text'>축구채널 개국</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>09.07</strong>
                      <span className='history_text'>스포츠 포탈서비스(sbssportal.com) 오픈</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>09.29</strong>
                      <span className='history_text'>SBSi, ‘SBS美’ 법인 설립 완료</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>10.09</strong>
                      <span className='history_text'>국내 최초 평양에서 뉴스 생방송 실시</span>
                    </div>
                  </dd>
                </dl>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>2001</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>01.06</strong>
                      <span className='history_text'>‘제1회 SBS 세계문화체험단’ 시행 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>04.06</strong>
                      <span className='history_text'>국내 최초 HDTV 생중계 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>10.11</strong>
                      <span className='history_text'>2001 SBS 프로골프 최강전 개최</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>10.26</strong>
                      <span className='history_text'>국내 최초 HDTV 본방송 실시, 관악산 DTV 송신소 개국</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>11.23</strong>
                      <span className='history_text'>SBS-SFAA 서울컬렉션 2002S/S 개최</span>
                    </div>
                  </dd>
                </dl>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>2002</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>02.01</strong>
                      <span className='history_text'>SBS 드라마플러스 채널 개국</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>03.18</strong>
                      <span className='history_text'>디지털 오디오 아카이브 ‘뮤직뱅크’ 서비스 개시</span>
                    </div>
                  </dd>
                </dl>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>2003</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>03.31</strong>
                      <span className='history_text'>SBS-한국IBM, 뉴스디지털 시스템 개발 및 구축을 위한 조인식</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>04.18</strong>
                      <span className='history_text'>한국민영방송협회 공식 출범</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>05.08</strong>
                      <span className='history_text'>2002 한일월드컵 1주년 기념 세계 최대 야외 오페라 ‘투란도트’ 공연 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>06.01</strong>
                      <span className='history_text'>SBSUSA → SBSInternational 사명 변경</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>07.14</strong>
                      <span className='history_text'>SBS, 국내 최초 미국 위성방송 에코스타 진출</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>07.15</strong>
                      <span className='history_text'>2003 PeaceCup KOREA 개최</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>10.07</strong>
                      <span className='history_text'>평양 ‘류경 정주영 체육관’ 개관 기념 &#60;통일농구&#62; 및 전야제 &#60;통일음악회&#62; 단독 생중계</span>
                    </div>
                  </dd>
                </dl>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>2004</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>02.24</strong>
                      <span className='history_text'>시청자 만족지수(ASI) 개발 완료</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>03.01</strong>
                      <span className='history_text'>SBS 목동 신사옥 그랜드 오픈</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>05.07</strong>
                      <span className='history_text'>제1차 서울디지털포럼 개최</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>06.01</strong>
                      <span className='history_text'>뉴스 제작 전 과정 디지털 전환</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>09.15</strong>
                      <span className='history_text'>제1차 미래한국 리포트 개최</span>
                    </div>
                  </dd>
                </dl>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>2005</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>08.16</strong>
                      <span className='history_text'>UTV 개국 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>08.23</strong>
                      <span className='history_text'>광복 60년 SBS 특별 기획 &#60;조용필 평양 2005&#62; 공연</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>11.25</strong>
                      <span className='history_text'>SBS 프로덕션, 한국 방송 최초로 인도네시아 현지 방송 프로덕션 설립</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>11.30</strong>
                      <span className='history_text'>SBS 프로덕션 1,000만 불 수출탑 수상 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>12.01</strong>
                      <span className='history_text'>지상파 DMB, SBSⓤ 개국</span>
                    </div>
                  </dd>
                </dl>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>2006</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>02.02</strong>
                      <span className='history_text'>SBS-한국 문화 컨텐츠진흥원, ‘글로벌 모바일콘텐츠 어워드’ 공동 개최 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>04.14</strong>
                      <span className='history_text'>대한민국 역사상 최초 시도! ‘한국 우주인 배출사업’, SBS 주관방송사로 선정</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>04.21</strong>
                      <span className='history_text'>한국 1호 우주인 선발 출정식 - &#60;가자, 우주로! 미래로!&#62; </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>04.24</strong>
                      <span className='history_text'>SBS, 제51회 정보통신의 날 대통령 표창</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>05.26</strong>
                      <span className='history_text'>세계 최초 ‘이동통신망 연동 DMB 양방향 데이터 서비스’ 개발 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>05.30</strong>
                      <span className='history_text'>멀티미디어팀, 국내 최초 ‘DTV 데이터방송 본방송’ 시연</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>06.08</strong>
                      <span className='history_text'>인터넷 라디오 ‘고릴라’ 서비스 개시</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>06.08</strong>
                      <span className='history_text'>한국방송 사상 최초 ‘SBS 데이터방송’ 개국</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>06.16</strong>
                      <span className='history_text'>2010 ~2016 올림픽 중계권 계약, 남북한 동시중계권 확보</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>06.23</strong>
                      <span className='history_text'>국내 최초 5 . 1채널 월드컵 축구방송</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>08.25</strong>
                      <span className='history_text'>2010년, 2014년 월드컵 중계권 확보</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>10.13</strong>
                      <span className='history_text'>제1회 국립국어원·SBS 방송 언어 공동 연구 발표회 개최</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>11.13</strong>
                      <span className='history_text'>이숙영·최화정 ‘The voice of SBS’ 명예전당 입성</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>11.30</strong>
                      <span className='history_text'>Asian Television Award 2006 아시아 최고 지상파 방송사로 선정</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>12.01</strong>
                      <span className='history_text'>SBS 글로벌 비즈니스 사이트 오픈</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>12.01</strong>
                      <span className='history_text'>SBSⓤ 지상파DMB BIFS(양방향데이터방송) 시범서비스 개시</span>
                    </div>
                  </dd>
                </dl>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>2007</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>02.08</strong>
                      <span className='history_text'>국내 최초 DTV 자막방송 송출 시작</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>05.04</strong>
                      <span className='history_text'>SBS 아트텍, SBS방송아카데미 인수</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>07.07</strong>
                      <span className='history_text'>국내 최초 DTV 자막방송 본방송 개시</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>10.25</strong>
                      <span className='history_text'>SBS골프, 북한에서 골프사상 첫 HD 생중계</span>
                    </div>
                  </dd>
                </dl>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>2008</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>03.03</strong>
                      <span className='history_text'>SBS 홀딩스 설립 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>04.08</strong>
                      <span className='history_text'>한국 최초 우주인 이소연 탄생, SBS 우주 생중계</span>
                    </div>
                  </dd>
                </dl>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>2009</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>01.01</strong>
                      <span className='history_text'>E! TV 개국</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>02.27</strong>
                      <span className='history_text'>상호변경 ㈜SBS홀딩스 → ㈜SBS미디어홀딩스</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>03.25</strong>
                      <span className='history_text'>2009 ISU 세계피겨스케이팅 선수권대회 중계</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>09.16</strong>
                      <span className='history_text'>SBS i → ‘SBS 콘텐츠허브’, SBS드라마플러스 → ‘SBS 플러스’로 채널명 변경</span>
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            {/* <!-- 2010 --> */}
            <div className='sbsabout_inner tablist_2010' id='tab_2'>
              <div className='tab_term_w' style={sectionStyle3}>
                <div className='tab_term_cont'>
                  <strong className='tab_term_years'>2010-2020</strong>
                </div>
              </div>
              <div className='history_list_w'>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>2010</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>01.19</strong>
                      <span className='history_text'>경제 전문 채널 SBS CNBC 개국</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>02.12</strong>
                      <span className='history_text'>2010 밴쿠버동계올림픽 단독 중계 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>03.01</strong>
                      <span className='history_text'>SBS 골프채널 → ‘SBS Golf’, SBS스포츠채널 → ‘SBS Sports’로 채널명 변경 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>05.07</strong>
                      <span className='history_text'>사회공헌프로그램 ‘2010 SBS 희망TV’ 방송 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>06.11</strong>
                      <span className='history_text'>2010 남아공 월드컵 단독 중계 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>08.16</strong>
                      <span className='history_text'>SBS 창사20주년 기념식, 역사관 개관, 투모로우 페스티벌</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>12.01</strong>
                      <span className='history_text'>SBS Sports → ‘SBSESPN’으로 채널명 변경</span>
                    </div>
                  </dd>
                </dl>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>2011</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>03.09</strong>
                      <span className='history_text'>SBS 라디오 팟캐스트 서비스 실시</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>03.21</strong>
                      <span className='history_text'>박소현 ‘ The Voice of SBS’ 명예전당 입성 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>04.12</strong>
                      <span className='history_text'>2011년 사회공헌 프로젝트 선포식(초대 회장 윤석민) 및 ‘SBS희망TV24’ 제작발표회</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>07.01</strong>
                      <span className='history_text'>SBS, 올림픽 중계권 2018~2024까지 확보</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>11.01</strong>
                      <span className='history_text'>바이아컴 제휴(SBSMTV, nickeiodeon 개국) </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>11.01</strong>
                      <span className='history_text'>E! TV → ‘SBS E!’로 채널명 변경</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>11.01</strong>
                      <span className='history_text'>양방향 데이터방송 서비스 실시</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>11.14</strong>
                      <span className='history_text'>국내 최초 미디어렙 ‘미디어 크리에이트’ 출범식</span>
                    </div>
                  </dd>
                </dl>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>2012</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>05.01</strong>
                      <span className='history_text'>파워FM, 전체 청취율 최초 1위 달성 (한국리서치 조사)</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>07.01</strong>
                      <span className='history_text'>지상파 연합 N스크린 서비스 ‘pooq’ 오픈</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>07.01</strong>
                      <span className='history_text'>SBS 프리즘 타워 준공 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>07.11</strong>
                      <span className='history_text'>2012 런던올림픽 방송단 발대식 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>07.26</strong>
                      <span className='history_text'>희망TV-초록우산 어린이재단, ‘마천 드림오케스트라’ 창단식</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>10.01</strong>
                      <span className='history_text'>러브FM, 신분당선 ‘오픈 스튜디오’ 오픈</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>10.25</strong>
                      <span className='history_text'>‘2012 굿디자인 어워드’ 대상 지식경제부 장관상 수상 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>10.29</strong>
                      <span className='history_text'>24시간 종일 방송 실시</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>11.01</strong>
                      <span className='history_text'>라디오 공개 스튜디오 ‘더 스튜디오 樂(락)’ 오픈</span>
                    </div>
                  </dd>
                </dl>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>2013</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>06.10</strong>
                      <span className='history_text'>‘서울디지털포럼’ 정보문화유공 대통령 표창 수상 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>12.31</strong>
                      <span className='history_text'> &lt;2013 SBS 연기대상&gt; 국내 방송사상 최초 TV와 SNS로 세계 동시 생중계</span>
                    </div>
                  </dd>
                </dl>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>2014</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>01.01</strong>
                      <span className='history_text'>SBS E! → ‘SBSfun E’, SBSESPN → ‘SBS Sports’로 이름 변경</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>01.20</strong>
                      <span className='history_text'>2014 소치동계올림픽 방송단 발대식</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>04.21</strong>
                      <span className='history_text'>SBS 등 지상파 방송 4사 UHDTV 실험방송 추진 협약</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>05.01</strong>
                      <span className='history_text'>SBS A&T 설립(SBS뉴스텍, SBS아트텍 합병) </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>06.01</strong>
                      <span className='history_text'>세계 최초 월드컵 UHDTV 생중계</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>06.01</strong>
                      <span className='history_text'>스마트미디어렙 설립</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>10.10</strong>
                      <span className='history_text'>중국판 &#60;런닝맨&#62; ‘달려라 형제’ 중국 전역에 첫 방송</span>
                    </div>
                  </dd>
                </dl>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>2015</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>01.21</strong>
                      <span className='history_text'>SBS-한국문화재재단, ‘우리 문화유산의 가치 인식 확대’ 위한 업무협약 체결</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>02.27</strong>
                      <span className='history_text'>SBS 뉴스 브랜드 디자인, 세계적 권위의 i F 디자인상 수상</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>05.04</strong>
                      <span className='history_text'>보도국 뉴미디어부 팟캐스트 &#60;골룸&#62; 오픈</span>
                    </div>
                  </dd>
                </dl>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>2016</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>01.20</strong>
                      <span className='history_text'>세계 최초 ATSC 3.0 시스템 적용한 UHD 실험방송 성공 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>03.09</strong>
                      <span className='history_text'>삼성전자와 공동으로 MMT 기술 기반 UHD 본 방송 실험 성공</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>03.10</strong>
                      <span className='history_text'>SBS-국립국어원 방송언어문화 개선을 위한 공동연구 협약 체결</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>06.20</strong>
                      <span className='history_text'>SBS 모바일 콘텐츠 브랜드 ‘모비딕’ 론칭 제작발표회</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>07.01</strong>
                      <span className='history_text'>SBS 팟캐스트 전문채널 ‘고릴라팟’ 오픈</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>07.15</strong>
                      <span className='history_text'>ATSC 3.0 UHD 방송 SFN테스트 성공</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>09.02</strong>
                      <span className='history_text'>‘KF -X 관련 보도’, 뉴스 최초로 ‘제43회 한국방송대상’ 대상 수상</span>
                    </div>
                  </dd>
                </dl>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>2017</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>02.01</strong>
                      <span className='history_text'>파워FM &#60;두시탈출 컬투쇼&#62; 10년 연속 프로그램 청취율 1위</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>08.01</strong>
                      <span className='history_text'>SBS콘텐츠허브, ‘SBS네오파트너스’와 ‘SBSI&M’ 설립</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>09.01</strong>
                      <span className='history_text'>DMC미디어 인수</span>
                    </div>
                  </dd>
                </dl>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>2018</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>12.01</strong>
                      <span className='history_text'>미디어크리에이트, ‘SBS M&C’로 사명 변경</span>
                    </div>
                  </dd>
                </dl>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>2019</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>02.21</strong>
                      <span className='history_text'>‘끝까지 판다’팀, ‘제45회 한국방송대상’ 대상 수상</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>03.13</strong>
                      <span className='history_text'>SBS, 세계 최초 5G 기술 기반 UHD 중계방송 성공 </span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>04.24</strong>
                      <span className='history_text'>24시간 온라인 뉴스채널 SBS 모바일24 오픈</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>09.18</strong>
                      <span className='history_text'>글로벌 OTT ‘WAVVE’ 출범</span>
                    </div>
                  </dd>
                </dl>
                {/* <!-- 년도 --> */}
                <dl className='history_list'>
                  <dt className='history_year'>2020</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>04.01</strong>
                      <span className='history_text'>SBS 드라마 스튜디오‘㈜스튜디오S’출범</span>
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>11.14</strong>
                      <span className='history_text'>SBS 창사 30주년</span>
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            {/* <!-- 2021 --> */}
            {/* <div className='sbsabout_inner tablist_2021'>
              <div className='tab_term_w' style={sectionStyle4}>
                <div className='tab_term_cont'>
                  <strong className='tab_term_years'>2021-현재</strong>
                </div>
              </div>
              <div className='history_list_w'>
                <dl className='history_list'>
                  <dt className='history_year'>2021</dt>
                  <dd className='history_inner'>
                    <div className='history_row'>
                      <strong className='history_date'>01.19</strong>
                      <span className='history_text' />
                    </div>
                    <div className='history_row'>
                      <strong className='history_date'>01.19</strong>
                      <span className='history_text' />
                    </div>
                  </dd>
                </dl>
              </div>
            </div> */}

          </div>
        </div>
        {/* <!-- 풋터 --> */}
        <MainBottom />
      </div>

    </>
  );
}

export async function getServerSideProps(ctx) {
  // header에서 meta teg에 넣어줄 데이터를 가져 오기 위함
  const { pageSection, pageCategory } = ctx.query;
  const { cookies } = ctx.req;
  const { LOGIN_JWT } = cookies;

  const jWTCheck = !!LOGIN_JWT;
  const metaTagData = getMetaTagData(ctx.req.url, pageSection, pageCategory);

  return { props: { metaTagData, jWTCheck } };
}

export default HistoryGraph;
